import { createFeatureSelector, createSelector } from '@ngrx/store';

import { State } from '@app/features/dashboard/state/reducers';

import { selectPolicyState } from '@app/stp/state/selectors';

import { ChangeTypeEnum } from '@global/infrastructure/enums/change-type.enum';


const selectDashboardStore = createFeatureSelector<State>('dashboardStore');

const selectDashboardNavigation = createSelector(
  selectDashboardStore,
  (state: State) => state.dashboardNavigationState
);

const selectDashboardFeatureState = createSelector(
  selectDashboardStore,
  (state: State) => state?.dashboardState
);

export const getPolicyDetails = createSelector(
  selectDashboardFeatureState,
  state => state.policyDetails
);

export const getVehicleDetails = createSelector(
  selectDashboardFeatureState,
  state => {
    const policy = state?.policyDetails?.permanent;
    return { make: policy?.yourCar, reg: policy?.yourRegistration };
  }
);

export const getAlterationOptionsWithPolicyChangeType = createSelector(
  selectDashboardFeatureState,
  state => ({alterOptions: state.alterOptions, policyChangeType: state.policyChangeType})
);

export const selectPolicyChangeType = createSelector(
  selectDashboardFeatureState,
  state => state?.policyChangeType
);

export const selectRenewal = createSelector(
  selectDashboardFeatureState,
  state => state.renewal
);

export const selectPolicyChangeDate = createSelector(
  selectDashboardFeatureState,
  state => state.policyChangeDate
);

export const selectPolicyChangeEndDate = createSelector(
  selectDashboardFeatureState,
  state => state.policyChangeEndDate
);

export const selectHasAlreadyMovedAddress = createSelector(
  selectDashboardFeatureState,
  state => state.hasMovedAlready
);

export const getError = createSelector(
  selectDashboardFeatureState,
  state => state.error
);

export const selectPromoCode = createSelector(
  selectDashboardFeatureState,
  state => state.promoCode
);

export const selectDashboardNavigationAndProperties = createSelector(
  selectDashboardNavigation,
  selectPolicyChangeType,
  selectPolicyChangeDate,
  selectPolicyChangeEndDate,
  selectPromoCode,
  selectRenewal,
  (navigationState, changeType, startDate, endDate, promoCode, renewal) => ({...navigationState, changeType, startDate, endDate, promoCode, renewal})
);

export const selectPendingTempChangesStatus = createSelector(
  selectPolicyState,
  selectPolicyChangeType,
  (state, changeType) => {
    const {
      lobData: {
        mOTLine_Ext: {
          coverables: { drivers, motVehicles },
        },
      },
    } = state?.initialState?.policyDetails?.result || null;
    return {
      hasPendingTempChanges: drivers.filter(d => d.driverType === ChangeTypeEnum.Temporary).length > 0 ||
        motVehicles.filter(v => v.vehicle.typeOfVehicle === ChangeTypeEnum.Temporary).length > 0 ||
        motVehicles.find(v => v.vehicle.typeOfVehicle === ChangeTypeEnum.Permanent).vehicle.schItems[0]?.mainDestination,
      changeType: changeType.toLowerCase() as ChangeTypeEnum
    };
  }
);


